import { useEffect } from "react";

interface JsonLdProps {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
}

export default function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.id = `jsonld-${id}`;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById(`jsonld-${id}`);
      if (existing) existing.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
